export default {
    title: 'Standard Features',
    items: [
        'Granite countertops throughout',
        'High ceilings in entry and living with crown molding',
        'Tile floors everywhere except carpet in bedrooms',
        'Kitchens include stainless appliances, gas cooktop, double ovens, tile backsplash and spacious pantries',
        'Custom built cabinets with full extension drawers',
        'Two inch faux wood blinds throughout',
        'Sealed gas fireplace with rock or brick surround',
        'Oil rubbed bronze, nickel, or chrome hardware and fixtures',
        'Master bath offers large soaking tub plus separate shower and a double sink vanity',
        'Professionally landscaped lawn with irrigation system',
        'Floored attic space for additional storage'
    ]
};